import appPaths from "~/src/router/app.paths";


export default [
  {
    path: appPaths.authLogin,
    name: 'auth-login',
    component: () =>
      import(
        /* webpackChunkName: "auth-signin" */ "@/modules/auth/auth-login.vue"
      ),
    meta: {
      layout: "auth",
      title: "SignIn",
    },
  },
  {
    path: appPaths.authForgotPassword,
    name: 'auth-forgot-password',
    component: () =>
      import(
        /* webpackChunkName: "auth-forgot-password" */ "@/modules/auth/auth-forgot-password.vue"
      ),
    meta: {
      layout: "auth",
      title: "Forgot Password",
    },
  },
  {
    path: appPaths.authResetPassword,
    name: 'auth-reset-password',
    component: () =>
      import(
        /* webpackChunkName: "auth-reset-password" */ "@/modules/auth/auth-reset-password.vue"
      ),
    meta: {
      layout: "auth",
      title: "Reset Password",
    },
  },
];
